import { z } from "zod";
import { AgencyIdSchema, ProjectIdSchema, RevisionIdSchema } from "../primitives/ids.js";
/** BG-008 — machine-readable BusinessGraph revision change entry. */
export const BusinessGraphDiffChangeV1Schema = z
    .object({
    /**
     * Dot-separated path; array items with stable `id` or `fieldPath` use bracket segments
     * (e.g. `provenance.records[prov_services].reviewState`, `services[s1].name`).
     */
    path: z.string().min(1),
    op: z.enum(["add", "remove", "replace"]),
    /** JSON-serialized values; never include Run/private ledgers. */
    before: z.unknown().optional(),
    after: z.unknown().optional(),
})
    .strict();
export const BusinessGraphDiffResultV1Schema = z
    .object({
    schemaVersion: z.literal("business-graph-diff.v1.0"),
    agencyId: AgencyIdSchema,
    projectId: ProjectIdSchema,
    fromRevisionId: RevisionIdSchema,
    toRevisionId: RevisionIdSchema,
    identical: z.boolean(),
    changes: z.array(BusinessGraphDiffChangeV1Schema),
    /** Human-readable lines for Studio panel. */
    humanSummary: z.array(z.string().min(1)),
})
    .strict();
//# sourceMappingURL=business-graph-diff.js.map